import { FaExclamationTriangle } from 'react-icons/fa';
import { LayoutProps } from '../../@types'

// services

const Error = ({ children }: LayoutProps): JSX.Element => {

  return (
    <div className="errorFeedback">
      <FaExclamationTriangle style={{ marginTop: '-4px', marginRight: '4px', marginLeft: '4px' }} /> {children}
    </div>
  );
};

export default Error;